<template>
  <div class="monthly">
    <div class="monthly-content">
      <div class="monthly-content-head">
        <div>管理制度</div>
        <div><img src="@/assets/line.png" alt="" /></div>
        <div>THE MANAGEMENT SYSTEM</div>
      </div>
      <div class="monthly-content-main" style="background: #ffffff">
        <a-collapse
          accordion
          :bordered="false"
          @change="collapseChange"
          v-model="activeKey"
        >
          <a-collapse-panel key="1" :show-arrow="false">
            <!-- 头部 -->
            <template slot="header">
              <div class="head-item">
                <div></div>
                <div>财务</div>
                <div :class="activeKey == 1 ? 'iconActive' : ''">
                  <a-icon type="caret-up" style="color: #999999" />
                </div>
              </div>
            </template>
            <!-- 内容 -->
            <div class="panel-content">
              <div
                class="panel-content-item"
                v-for="(v, i) in navList.filter(
                  (item) => item.publicityType == 0
                )"
                :key="i"
                @mouseover="panelItemOver(i)"
                @mouseout="panelItemOut"
                @click="goDetail(v)"
              >
                <div :style="{ color: itemCur == i ? '#c8000e' : '#333333' }">
                  {{ v.title }}
                </div>
                <div :style="{ color: itemCur == i ? '#c8000e' : '#777777' }">
                  {{ v.releaseDate }}
                </div>
              </div>
            </div>
          </a-collapse-panel>
          <a-collapse-panel key="2" :disabled="false" :show-arrow="false">
            <template slot="header">
              <div class="head-item">
                <div></div>
                <div>工作</div>
                <div :class="activeKey == 2 ? 'iconActive' : ''">
                  <a-icon type="caret-up" style="color: #999999" />
                </div>
              </div>
            </template>
            <div class="panel-content">
              <div
                class="panel-content-item"
                v-for="(v, i) in navList.filter(
                  (item) => item.publicityType == 1
                )"
                :key="i"
                @mouseover="workItem = i"
                @mouseout="workItem = -1"
                @click="goDetail(v)"
              >
                <div :style="{ color: workItem == i ? '#c8000e' : '#333333' }">
                  {{ v.title }}
                </div>
                <div :style="{ color: workItem == i ? '#c8000e' : '#777777' }">
                  {{ v.releaseDate }}
                </div>
              </div>
            </div>
          </a-collapse-panel>
        </a-collapse>
      </div>
      <div class="monthly-content-foot">
        <a-pagination
          :pageSize="pageSize"
          v-model="current"
          :total="total"
          @change="changePage"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeKey: 1,
      isShow: false,
      pagiCur: 1,
      itemCur: -1,
      workItem: -1,
      pageInfo: {},
      navList: [],
      pageSize: 10,
      current: 1,
      total: "",
      FILE_BASE_URL: this.$API.FILE_BASE_URL,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    collapseChange() {},
    panelItemOver(i) {
      this.itemCur = i;
    },
    panelItemOut() {
      this.itemCur = -1;
    },
    // goDetail(){
    //     this.$router.push('/information/management/detail?index=3&title=信息公示&curIndex=4&type=5')
    // },
    goDetail(item) {
      // 详情数据存本地存储，详情页直接本地存储获取
      localStorage.setItem("managerInfo", JSON.stringify(item));

      this.$router.push({
        path: "/information/management/detail?index=3&title=信息公示&curIndex=4&type=5",
      });
    },
    /**初试加载数据*/
    load(page = 1) {
      let params = {
        type: 4,
        // 'publicityType': 0,
        pageNo: page,
        pageSize: this.pageSize,
      };
      this.$API.queryPlacardPageList(params).then((res) => {
        this.navList = res.result.records;
        this.pageSize = res.result.size;
        this.total = res.result.total;
        this.pagiCur = res.result.pages;
        // console.log('this.navList' + this.navList )
      });
    },
    // 改变页码
    changePage(page) {
      this.load(page);
    },
  },
};
</script>
<style scoped lang="scss">
.iconActive {
  transform: rotate(180deg);
  transition: 0.5s;
}
.itemActive {
  color: #c8000e;
}
.monthly {
  width: 100%;
}
.monthly-content {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0 60px 0;
  .monthly-content-head {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > div:nth-child(1) {
      font-size: 26px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
      font-weight: 700;
      color: #333333;
    }
    > div:nth-child(2) {
      margin-top: 12px;
    }
    > div:nth-child(3) {
      font-size: 12px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 400;
      color: #999999;
      margin-top: 14px;
    }
  }
}
.head-item {
  display: flex;

  position: relative;
  > div:nth-child(1) {
    position: absolute;
    width: 20px;
    height: 20px;
    background: #f8b92b;
    border-radius: 0px 4px 0px 4px;
  }
  > div:nth-child(2) {
    z-index: 99;
    margin-left: 10px;
    font-size: 16px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
    font-weight: 700;
    color: #333333;
  }
  > div:nth-child(3) {
    margin-left: 9px;
  }
}
.ant-collapse-borderless {
  background: #ffffff;
}
.ant-collapse-borderless > .ant-collapse-item {
  border-bottom: none;
}
.panel-content {
  .panel-content-item {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #efefef;
    padding: 23px 0;
    cursor: pointer;
    > div:nth-child(1) {
      font-size: 16px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 400;
      color: #333333;
    }
    > div:nth-child(2) {
      font-size: 16px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 400;
      color: #777777;
    }
  }
}
.monthly-content-foot {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}
::v-deep .ant-pagination-item-active a {
  color: #c8000e;
  border-color: #c8000e;
}
::v-deep .ant-pagination-item-active {
  color: #c8000e;
  border-color: #c8000e;
}
::v-deep .ant-pagination-item-active:focus,
.ant-pagination-item-active:hover {
  color: #c8000e;
  border-color: #c8000e;
}
::v-deep .ant-pagination-item:focus,
.ant-pagination-item:hover {
  color: #c8000e;
  border-color: #c8000e;
}
::v-deep .ant-pagination-item:hover {
  color: #c8000e;
  border-color: #c8000e;
}
::v-deep .ant-pagination-item a:hover {
  color: #c8000e;
  border-color: #c8000e;
}
::v-deep .ant-pagination-prev:hover a {
  color: #c8000e;
  border-color: #c8000e;
}
::v-deep .ant-pagination-next:hover a {
  color: #c8000e;
  border-color: #c8000e;
}
</style>
